import request from './request';

export function getMyCommission() {
  return request.get('/api/commission/myCommission');
}
export function withdraw(data) {
  return request.post('/api/commission/withdraw', data);
}
